import React from 'react';
import { useTranslation } from 'react-i18next';
import { ServiceType } from '../../types';

interface ServicePreparationSectionProps {
  serviceType?: ServiceType;
  problemDescription: string;
  onServiceTypeChange: (serviceType: ServiceType) => void;
  onProblemDescriptionChange: (value: string) => void;
  readOnly: boolean;
  problemDescriptionReadOnly?: boolean;
  showSparePartsButton?: boolean;
  onSparePartsClick?: () => void;
}

const ServicePreparationSection: React.FC<ServicePreparationSectionProps> = ({
  serviceType,
  problemDescription,
  onServiceTypeChange,
  onProblemDescriptionChange,
  readOnly,
  problemDescriptionReadOnly,
  showSparePartsButton = false,
  onSparePartsClick
}) => {
  const { t } = useTranslation();

  return (
    <section className="form-section">
      <div className="section-header">
        <h3>{t('machineForm.servicePreparation')}</h3>
        {showSparePartsButton && onSparePartsClick && (
          <button onClick={onSparePartsClick} className="btn-spareparts">
            <span className="material-icons">build</span> {t('machineForm.spareParts')}
          </button>
        )}
      </div>
      <div className="service-type-section">
        <label>{t('machineForm.serviceType')}</label>
        <div className="radio-group">
          <label>
            <input
              type="radio"
              value={ServiceType.TYPE1}
              checked={serviceType === ServiceType.TYPE1}
              onChange={(e) => onServiceTypeChange(e.target.value as ServiceType)}
              disabled={readOnly}
            />
            {t('serviceType.TYPE1')}
          </label>
          <label>
            <input
              type="radio"
              value={ServiceType.TYPE2}
              checked={serviceType === ServiceType.TYPE2}
              onChange={(e) => onServiceTypeChange(e.target.value as ServiceType)}
              disabled={readOnly}
            />
            {t('serviceType.TYPE2')}
          </label>
          <label>
            <input
              type="radio"
              value={ServiceType.TYPE3}
              checked={serviceType === ServiceType.TYPE3}
              onChange={(e) => onServiceTypeChange(e.target.value as ServiceType)}
              disabled={readOnly}
            />
            {t('serviceType.TYPE3')}
          </label>
          <label>
            <input
              type="radio"
              value={ServiceType.TYPE4}
              checked={serviceType === ServiceType.TYPE4}
              onChange={(e) => onServiceTypeChange(e.target.value as ServiceType)}
              disabled={readOnly}
            />
            {t('serviceType.TYPE4')}
          </label>
        </div>
      </div>
      <br />
      <div className="form-field">
        <label>{t('machineForm.issueNotified')}</label>
        <textarea
          rows={4}
          value={problemDescription}
          onChange={(e) => onProblemDescriptionChange(e.target.value)}
          readOnly={problemDescriptionReadOnly !== undefined ? problemDescriptionReadOnly : readOnly}
        />
      </div>
    </section>
  );
};

export default ServicePreparationSection;
